import { SelectDropdown } from 'components/dropdowns/select/select';
import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { EffectsContainer } from 'mixins/withEffects';
import { TopicThread } from 'models/topicThread';
import { CommentsService } from 'services/comments';
import './responseSetting.html';
import './responseSetting.scss';

components.preload('wcc-select');

export interface CommentResponseSettingVMConfig {
    comment: SubscribableOrNullableValue<TopicThread>
}

@injectable()
export default class CommentResponseSettingVM {
    private comment: Subscribable<TopicThread | undefined>

    labels = labels

    responseSettingSelect: SelectDropdown<boolean>

    busy = ko.observable(false);

    constructor(
        @inject(wccModules.componentConfig) config: CommentResponseSettingVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.commentsService) private commentsService: CommentsService,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        this.comment = ko.flattenComputed(config.comment);
        const isResponseMandatory = this.comment.pluck(c => c.isResponseMandatory, false);

        this.responseSettingSelect = new SelectDropdown({
            highlightActiveItem: true,
            theme: 'blue',

            items: [
                { title: labels.Mandatory.toLowerCase(), value: true },
                { title: labels.Optional.toLowerCase(), value: false }
            ]
        });

        this.responseSettingSelect.select(item => item.value === isResponseMandatory());

        effects.register([
            isResponseMandatory.subscribe(value => this.responseSettingSelect.select(item => item.value === value)),

            this.responseSettingSelect.selectedItem.subscribeNotNull(item => {
                if (item.value !== isResponseMandatory())
                    this.changeResponseSetting(item.value);
            })
        ]);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'topic__comment__response-setting': true
            }
        });
    }

    private async changeResponseSetting(isMandatory: boolean) {
        if (this.busy()) return;

        const comment = this.comment();

        try {
            if (comment == undefined)
                throw new Error(messages.InvalidRequest);

            this.busy(true);

            await this.commentsService.changeResponseSetting(comment, isMandatory);
        } catch (ex) {
            system.handleError(ex);
        } finally {
            this.busy(false);
        }
    }
}